import React from 'react'
import './future.css'


const Future = () => {
  return (
    <div className='divd'><div class="coin">
    <div class="side heads">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="70 20 380 500" enable-background="new 0 0 500 500" xmlSpace="preserve">
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M288.000000,501.000000 
	C192.000015,501.000000 96.500046,501.000000 1.000051,501.000000 
	C1.000034,334.333405 1.000034,167.666794 1.000017,1.000141 
	C167.666565,1.000094 334.333130,1.000094 500.999756,1.000047 
	C500.999847,167.666519 500.999847,334.333038 500.999939,500.999786 
	C430.166656,501.000000 359.333344,501.000000 288.000000,501.000000 
M98.264000,220.335724 
	C104.482521,227.326645 109.653969,227.012146 115.921989,220.283020 
	C115.952385,223.599518 115.944221,226.916901 116.022079,230.232285 
	C116.143494,235.402176 119.088997,238.722504 123.653130,238.919067 
	C128.311523,239.119705 131.828888,235.608337 131.941605,230.334152 
	C132.044281,225.530228 131.869888,220.720367 131.899307,214.991287 
	C131.914185,210.173065 132.039505,205.351898 131.911438,200.537491 
	C131.794159,196.129364 128.151550,192.626129 123.955597,192.583572 
	C119.443954,192.537811 116.253517,195.635971 116.044319,200.418427 
	C115.870392,204.394409 115.840225,208.376709 115.234039,211.891190 
	C110.204445,204.392563 104.056313,204.240280 97.825562,210.495270 
	C97.800919,207.507599 97.906235,204.511948 97.722961,201.534042 
	C97.400513,196.294922 93.558189,192.434311 88.963989,192.519104 
	C84.627800,192.599136 81.192078,196.527832 81.150505,201.741714 
	C81.112175,206.547470 81.307182,211.355087 81.285881,216.759766 
	C81.294380,217.164810 81.302887,217.569870 81.165237,218.497345 
	C81.214096,218.671432 81.262962,218.845535 81.259689,219.937271 
	C81.283699,223.629929 81.307709,227.322586 81.129372,231.545990 
	C81.341248,232.038361 81.553131,232.530716 81.978546,233.714188 
	C83.801773,237.712921 86.965866,239.634430 91.196777,238.557053 
	C95.647629,237.423676 97.410423,234.091431 97.281265,229.499466 
	C97.188416,226.198303 97.581749,222.883453 98.264000,220.335724 
M325.754486,198.342789 
	C323.843964,198.342789 321.933441,198.342789 320.050385,198.342789 
	C320.050385,201.055450 320.050385,202.936264 320.050385,205.346771 
	C324.186768,205.346771 327.923096,205.346771 332.201263,205.346771 
	C331.830811,208.176453 331.539185,210.404083 331.247559,212.631714 
	C330.979584,212.205444 330.711578,211.779190 330.443604,211.352921 
	C327.814209,211.932404 324.421661,211.693115 322.725647,213.273956 
	C319.829437,215.973541 321.995697,219.216476 324.152740,221.611511 
	C328.583069,226.530655 333.228546,231.256012 337.087250,235.324860 
	C339.526642,233.663269 341.386627,232.396317 343.268311,231.114609 
	C339.319214,227.395187 335.990631,224.260208 332.211975,220.701309 
	C339.098419,221.314240 344.792786,221.821060 351.128357,222.384964 
	C351.128357,226.437119 351.128357,230.650894 351.128357,234.652710 
	C354.020325,234.652710 356.267151,234.652710 358.939026,234.652710 
	C358.939026,224.700516 358.939026,215.109802 358.939026,205.353455 
	C363.601166,205.353455 367.821960,205.353455 372.538666,205.353455 
	C372.391724,207.956573 372.265320,210.196518 372.207428,211.222092 
	C368.677460,212.036560 364.906830,211.778030 363.336151,213.512146 
	C360.383881,216.771606 363.405884,220.096909 365.643372,222.674942 
	C374.119385,232.440811 384.386414,237.395493 397.580017,233.815201 
	C398.325012,233.613037 399.168121,233.387436 399.886688,233.541275 
	C402.558746,234.113327 405.197815,234.839493 408.717468,235.726624 
	C408.717468,224.734680 408.717468,215.020950 408.717468,205.320480 
	C411.107697,205.320480 412.854858,205.320480 415.140381,205.320480 
	C415.140381,215.337952 415.140381,225.073914 415.140381,234.726227 
	C417.949677,234.726227 420.210907,234.726227 423.026764,234.726227 
	C423.026764,224.705780 423.026764,214.966232 423.026764,205.353836 
	C425.167572,205.032669 426.732178,204.797943 428.546021,204.525833 
	C428.435577,202.284714 428.342743,200.401596 428.241302,198.343231 
	C393.957123,198.343231 360.324829,198.343231 325.754486,198.342789 
M187.340225,234.985733 
	C187.889481,233.647415 188.873840,232.321716 188.913040,230.968628 
	C189.086456,224.981491 188.988281,218.986496 188.988312,212.994339 
	C188.988358,206.732819 188.988312,200.471283 188.988312,194.363861 
	C186.046249,194.363861 183.812759,194.363861 181.143661,194.363861 
	C181.143661,199.992905 181.143661,205.249725 181.143661,210.724976 
	C174.953720,210.724976 169.222229,210.724976 162.949692,210.724976 
	C162.949692,205.086807 162.949692,199.688782 162.949692,194.320526 
	C160.165344,194.320526 157.938232,194.320526 155.716797,194.320526 
	C155.716797,208.025574 155.716797,221.385330 155.716797,234.629578 
	C158.362076,234.629578 160.586945,234.629578 163.175507,234.629578 
	C163.175507,228.645767 163.175507,223.046127 163.175507,217.302917 
	C169.292465,217.302917 175.024170,217.302917 181.363434,217.302917 
	C181.363434,223.292358 181.363434,229.017471 181.363434,235.015839 
	C183.457520,235.015839 184.942688,235.015839 187.340225,234.985733 
M298.399078,232.965775 
	C298.414673,228.639053 298.295319,224.306564 298.479614,219.987030 
	C298.716522,214.433762 301.237671,211.717545 305.767365,211.741425 
	C309.957825,211.763519 311.829987,214.197678 311.968628,220.160004 
	C312.079926,224.946762 311.991150,229.738159 311.991150,234.674942 
	C314.659973,234.674942 316.858307,234.674942 319.375336,234.674942 
	C319.375336,229.209076 319.558228,224.059570 319.339325,218.927200 
	C318.792725,206.111832 311.261749,201.917572 299.935242,207.964020 
	C299.700806,208.089157 299.298615,207.899948 298.401855,207.782166 
	C298.401855,202.966721 298.401855,198.052017 298.401855,193.043793 
	C295.602539,193.043793 293.380585,193.043793 291.175293,193.043793 
	C291.175293,207.131180 291.175293,220.872742 291.175293,235.499298 
	C293.848511,234.880081 296.076447,234.364029 298.399078,232.965775 
M228.674179,215.749390 
	C230.658295,214.910156 232.581940,213.847717 234.642227,213.289780 
	C237.067047,212.633087 239.713470,211.823166 242.062332,212.233337 
	C243.403336,212.467529 244.343109,214.999298 246.159988,217.427216 
	C242.754471,217.587906 240.972885,217.662567 239.192459,217.758575 
	C237.365936,217.857056 235.523529,217.855576 233.717926,218.109894 
	C228.842545,218.796555 225.418381,222.178253 225.123428,226.443619 
	C224.821915,230.803925 227.708939,234.878326 232.789871,235.252258 
	C236.895935,235.554443 241.129944,234.118591 245.736938,233.385330 
	C246.214066,236.945099 249.639633,234.765976 252.764908,234.740356 
	C252.764908,228.100983 253.085144,221.786957 252.672516,215.521179 
	C252.280289,209.565231 248.176315,206.092880 241.665421,205.218689 
	C235.227234,204.354248 228.830521,207.195541 226.914078,212.094513 
	C226.545456,213.036850 227.524994,214.506577 228.674179,215.749390 
M193.122116,217.102737 
	C193.087341,219.098190 192.868866,221.110596 193.050964,223.086060 
	C193.690948,230.028870 199.401932,235.221497 206.859406,235.802429 
	C213.447769,236.315659 219.087097,232.586792 221.286850,225.041199 
	C217.609024,226.267181 214.790527,227.488373 211.845428,228.101410 
	C209.385803,228.613373 206.576370,229.043243 204.303711,228.316055 
	C202.676865,227.795532 201.681213,225.302353 200.403946,223.689316 
	C200.697647,223.205978 200.991364,222.722656 201.285065,222.239334 
	C208.306122,222.239334 215.327194,222.239334 222.245697,222.239334 
	C222.970886,214.300903 220.183838,209.050583 214.318420,206.414581 
	C205.718872,202.549805 197.169525,206.564301 193.122116,217.102737 
M269.487701,205.994568 
	C268.384949,207.611710 267.282196,209.228867 265.883240,211.280350 
	C268.855804,212.034363 270.365295,212.417236 271.994049,212.830383 
	C271.994049,216.117538 271.993378,219.106918 271.994171,222.096298 
	C271.997223,233.349014 275.414246,236.251801 286.669281,234.482452 
	C286.669281,232.615829 286.669281,230.741547 286.669281,228.867264 
	C286.354523,229.159363 286.039795,229.451462 285.725037,229.743546 
	C283.701141,228.325989 280.305786,227.200211 279.929626,225.432114 
	C279.060059,221.344925 279.653351,216.946503 279.653351,212.447800 
	C282.411407,212.220291 284.664551,212.034439 287.125244,211.831482 
	C287.125244,209.879257 287.125244,208.125320 287.125244,206.219574 
	C284.604614,206.043625 282.336609,205.885300 279.889587,205.714493 
	C279.658203,203.091995 279.447144,200.699615 279.239624,198.347504 
	C276.885529,198.347504 274.969543,198.347504 273.620361,198.347504 
	C272.413330,201.179688 271.392731,203.574387 269.487701,205.994568 
M257.680786,193.060974 
	C257.413757,194.471344 256.922974,195.880463 256.915039,197.292282 
	C256.851746,208.577347 256.867126,219.862961 256.897827,231.148300 
	C256.901215,232.395538 257.152161,233.642136 257.260742,234.636658 
	C259.805603,234.636658 261.882172,234.636658 263.873352,234.636658 
	C263.873352,220.579254 263.873352,206.892059 263.873352,192.886795 
	C261.883057,192.886795 260.249725,192.886795 257.680786,193.060974 
z"/>
<path fill="#655AE9" opacity="1.000000" stroke="none" 
	d="
M326.223511,198.343018 
	C360.324829,198.343231 393.957123,198.343231 428.241302,198.343231 
	C428.342743,200.401596 428.435577,202.284714 428.546021,204.525833 
	C426.732178,204.797943 425.167572,205.032669 423.026764,205.353836 
	C423.026764,214.966232 423.026764,224.705780 423.026764,234.726227 
	C420.210907,234.726227 417.949677,234.726227 415.140381,234.726227 
	C415.140381,225.073914 415.140381,215.337952 415.140381,205.320480 
	C412.854858,205.320480 411.107697,205.320480 408.717468,205.320480 
	C408.717468,215.020950 408.717468,224.734680 408.717468,235.726624 
	C405.197815,234.839493 402.558746,234.113327 399.886688,233.541275 
	C399.168121,233.387436 398.325012,233.613037 397.580017,233.815201 
	C384.386414,237.395493 374.119385,232.440811 365.643372,222.674942 
	C363.405884,220.096909 360.383881,216.771606 363.336151,213.512146 
	C364.906830,211.778030 368.677460,212.036560 372.207428,211.222092 
	C372.265320,210.196518 372.391724,207.956573 372.538666,205.353455 
	C367.821960,205.353455 363.601166,205.353455 358.939026,205.353455 
	C358.939026,215.109802 358.939026,224.700516 358.939026,234.652710 
	C356.267151,234.652710 354.020325,234.652710 351.128357,234.652710 
	C351.128357,230.650894 351.128357,226.437119 351.128357,222.384964 
	C344.792786,221.821060 339.098419,221.314240 332.211975,220.701309 
	C335.990631,224.260208 339.319214,227.395187 343.268311,231.114609 
	C341.386627,232.396317 339.526642,233.663269 337.087250,235.324860 
	C333.228546,231.256012 328.583069,226.530655 324.152740,221.611511 
	C321.995697,219.216476 319.829437,215.973541 322.725647,213.273956 
	C324.421661,211.693115 327.814209,211.932404 330.443604,211.352921 
	C330.711578,211.779190 330.979584,212.205444 331.247559,212.631714 
	C331.539185,210.404083 331.830811,208.176453 332.201263,205.346771 
	C327.923096,205.346771 324.186768,205.346771 320.050385,205.346771 
	C320.050385,202.936264 320.050385,201.055450 320.050385,198.342789 
	C321.933441,198.342789 323.843964,198.342789 326.223511,198.343018 
M392.087799,218.820801 
	C400.367737,219.359772 401.714630,217.047791 399.779144,205.271118 
	C393.398743,205.271118 386.967896,205.271118 380.184631,205.271118 
	C382.115936,212.133835 379.034485,217.044693 373.572937,220.667648 
	C381.007446,229.245880 395.028046,231.090668 400.480072,223.895248 
	C393.995728,225.088013 387.217773,227.009735 383.856628,220.110519 
	C382.647247,217.628143 383.395111,212.923447 385.097076,210.567322 
	C388.214294,206.251877 393.378845,206.627487 398.673706,207.675842 
	C398.377136,209.587769 398.135620,211.145004 397.906738,212.620590 
	C389.906647,213.432648 389.244781,214.049011 392.087799,218.820801 
M340.797729,205.136261 
	C340.226135,208.273087 339.654572,211.409897 339.082703,214.548294 
	C351.842499,216.394547 352.195801,215.135834 350.151764,205.037949 
	C347.368164,205.037949 344.547333,205.037949 340.797729,205.136261 
z"/>
<path fill="#655AE9" opacity="1.000000" stroke="none" 
	d="
M186.884033,235.000793 
	C184.942688,235.015839 183.457520,235.015839 181.363434,235.015839 
	C181.363434,229.017471 181.363434,223.292358 181.363434,217.302917 
	C175.024170,217.302917 169.292465,217.302917 163.175507,217.302917 
	C163.175507,223.046127 163.175507,228.645767 163.175507,234.629578 
	C160.586945,234.629578 158.362076,234.629578 155.716797,234.629578 
	C155.716797,221.385330 155.716797,208.025574 155.716797,194.320526 
	C157.938232,194.320526 160.165344,194.320526 162.949692,194.320526 
	C162.949692,199.688782 162.949692,205.086807 162.949692,210.724976 
	C169.222229,210.724976 174.953720,210.724976 181.143661,210.724976 
	C181.143661,205.249725 181.143661,199.992905 181.143661,194.363861 
	C183.812759,194.363861 186.046249,194.363861 188.988312,194.363861 
	C188.988312,200.471283 188.988358,206.732819 188.988312,212.994339 
	C188.988281,218.986496 189.086456,224.981491 188.913040,230.968628 
	C188.873840,232.321716 187.889481,233.647415 186.884033,235.000793 
z"/>
<path fill="#6054E8" opacity="1.000000" stroke="none" 
	d="
M298.351715,233.406860 
	C296.076447,234.364029 293.848511,234.880081 291.175293,235.499298 
	C291.175293,220.872742 291.175293,207.131180 291.175293,193.043793 
	C293.380585,193.043793 295.602539,193.043793 298.401855,193.043793 
	C298.401855,198.052017 298.401855,202.966721 298.401855,207.782166 
	C299.298615,207.899948 299.700806,208.089157 299.935242,207.964020 
	C311.261749,201.917572 318.792725,206.111832 319.339325,218.927200 
	C319.558228,224.059570 319.375336,229.209076 319.375336,234.674942 
	C316.858307,234.674942 314.659973,234.674942 311.991150,234.674942 
	C311.991150,229.738159 312.079926,224.946762 311.968628,220.160004 
	C311.829987,214.197678 309.957825,211.763519 305.767365,211.741425 
	C301.237671,211.717545 298.716522,214.433762 298.479614,219.987030 
	C298.295319,224.306564 298.414673,228.639053 298.351715,233.406860 
z"/>
<path fill="#655AE9" opacity="1.000000" stroke="none" 
	d="
M228.278381,215.741196 
	C227.524994,214.506577 226.545456,213.036850 226.914078,212.094513 
	C228.830521,207.195541 235.227234,204.354248 241.665421,205.218689 
	C248.176315,206.092880 252.280289,209.565231 252.672516,215.521179 
	C253.085144,221.786957 252.764908,228.100983 252.764908,234.740356 
	C249.639633,234.765976 246.214066,236.945099 245.736938,233.385330 
	C241.129944,234.118591 236.895935,235.554443 232.789871,235.252258 
	C227.708939,234.878326 224.821915,230.803925 225.123428,226.443619 
	C225.418381,222.178253 228.842545,218.796555 233.717926,218.109894 
	C235.523529,217.855576 237.365936,217.857056 239.192459,217.758575 
	C240.972885,217.662567 242.754471,217.587906 246.159988,217.427216 
	C244.343109,214.999298 243.403336,212.467529 242.062332,212.233337 
	C239.713470,211.823166 237.067047,212.633087 234.642227,213.289780 
	C232.581940,213.847717 230.658295,214.910156 228.278381,215.741196 
M234.621643,223.632034 
	C234.303192,225.077881 233.300430,227.421112 233.796219,227.799179 
	C235.213287,228.879761 237.684875,230.128983 238.931412,229.554291 
	C241.423019,228.405548 243.374527,226.085312 245.549042,224.248825 
	C245.221863,223.684967 244.894669,223.121124 244.567490,222.557266 
	C241.484360,222.758987 238.401230,222.960709 234.621643,223.632034 
z"/>
<path fill="#655AE9" opacity="1.000000" stroke="none" 
	d="
M193.207962,216.694870 
	C197.169525,206.564301 205.718872,202.549805 214.318420,206.414581 
	C220.183838,209.050583 222.970886,214.300903 222.245697,222.239334 
	C215.327194,222.239334 208.306122,222.239334 201.285065,222.239334 
	C200.991364,222.722656 200.697647,223.205978 200.403946,223.689316 
	C201.681213,225.302353 202.676865,227.795532 204.303711,228.316055 
	C206.576370,229.043243 209.385803,228.613373 211.845428,228.101410 
	C214.790527,227.488373 217.609024,226.267181 221.286850,225.041199 
	C219.087097,232.586792 213.447769,236.315659 206.859406,235.802429 
	C199.401932,235.221497 193.690948,230.028870 193.050964,223.086060 
	C192.868866,221.110596 193.087341,219.098190 193.207962,216.694870 
M213.503418,217.632233 
	C213.854492,217.027008 214.639267,216.268524 214.488113,215.840820 
	C213.268402,212.389572 210.555466,210.928802 207.094040,211.395477 
	C203.890869,211.827377 201.191971,213.212296 201.090439,217.680206 
	C205.149033,217.680206 208.922195,217.680206 213.503418,217.632233 
z"/>
<path fill="#6054E8" opacity="1.000000" stroke="none" 
	d="
M269.929932,205.981842 
	C271.392731,203.574387 272.413330,201.179688 273.620361,198.347504 
	C274.969543,198.347504 276.885529,198.347504 279.239624,198.347504 
	C279.447144,200.699615 279.658203,203.091995 279.889587,205.714493 
	C282.336609,205.885300 284.604614,206.043625 287.125244,206.219574 
	C287.125244,208.125320 287.125244,209.879257 287.125244,211.831482 
	C284.664551,212.034439 282.411407,212.220291 279.653351,212.447800 
	C279.653351,216.946503 279.060059,221.344925 279.929626,225.432114 
	C280.305786,227.200211 283.701141,228.325989 285.725037,229.743546 
	C286.039795,229.451462 286.354523,229.159363 286.669281,228.867264 
	C286.669281,230.741547 286.669281,232.615829 286.669281,234.482452 
	C275.414246,236.251801 271.997223,233.349014 271.994171,222.096298 
	C271.993378,219.106918 271.994049,216.117538 271.994049,212.830383 
	C270.365295,212.417236 268.855804,212.034363 265.883240,211.280350 
	C267.282196,209.228867 268.384949,207.611710 269.929932,205.981842 
z"/>
<path fill="#88F4CC" opacity="1.000000" stroke="none" 
	d="
M81.399399,216.161896 
	C81.307182,211.355087 81.112175,206.547470 81.150505,201.741714 
	C81.192078,196.527832 84.627800,192.599136 88.963989,192.519104 
	C93.558189,192.434311 97.400513,196.294922 97.722961,201.534042 
	C97.906235,204.511948 97.800919,207.507599 97.882362,211.296143 
	C97.620522,213.345840 97.301880,214.594650 96.518852,215.867401 
	C91.169441,215.981522 86.284424,216.071701 81.399399,216.161896 
z"/>
<path fill="#FDCD6F" opacity="1.000000" stroke="none" 
	d="
M115.746384,212.356201 
	C115.840225,208.376709 115.870392,204.394409 116.044319,200.418427 
	C116.253517,195.635971 119.443954,192.537811 123.955597,192.583572 
	C128.151550,192.626129 131.794159,196.129364 131.911438,200.537491 
	C132.039505,205.351898 131.914185,210.173065 131.408127,215.461288 
	C126.023720,215.918549 121.130501,215.905807 116.151779,215.545288 
	C115.959641,214.250397 115.853012,213.303299 115.746384,212.356201 
z"/>
<path fill="#F76FB8" opacity="1.000000" stroke="none" 
	d="
M116.237274,215.893066 
	C121.130501,215.905807 126.023720,215.918549 131.367279,215.922211 
	C131.869888,220.720367 132.044281,225.530228 131.941605,230.334152 
	C131.828888,235.608337 128.311523,239.119705 123.653130,238.919067 
	C119.088997,238.722504 116.143494,235.402176 116.022079,230.232285 
	C115.944221,226.916901 115.952385,223.599518 115.862381,219.446533 
	C115.947601,217.704391 116.092438,216.798737 116.237274,215.893066 
z"/>
<path fill="#2BC8F6" opacity="1.000000" stroke="none" 
	d="
M81.342636,216.460831 
	C86.284424,216.071701 91.169441,215.981522 96.565002,216.171127 
	C97.303093,217.492172 97.530647,218.533447 97.758209,219.574707 
	C97.581749,222.883453 97.188416,226.198303 97.281265,229.499466 
	C97.410423,234.091431 95.647629,237.423676 91.196777,238.557053 
	C86.965866,239.634430 83.801773,237.712921 81.930946,233.102203 
	C81.699471,231.998550 81.515594,231.506897 81.331711,231.015244 
	C81.307709,227.322586 81.283699,223.629929 81.411018,219.374619 
	C81.709541,218.464539 81.625885,218.185516 81.311386,217.974915 
	C81.302887,217.569870 81.294380,217.164810 81.342636,216.460831 
z"/>
<path fill="#6054E8" opacity="1.000000" stroke="none" 
	d="
M258.148590,192.973877 
	C260.249725,192.886795 261.883057,192.886795 263.873352,192.886795 
	C263.873352,206.892059 263.873352,220.579254 263.873352,234.636658 
	C261.882172,234.636658 259.805603,234.636658 257.260742,234.636658 
	C257.152161,233.642136 256.901215,232.395538 256.897827,231.148300 
	C256.867126,219.862961 256.851746,208.577347 256.915039,197.292282 
	C256.922974,195.880463 257.413757,194.471344 258.148590,192.973877 
z"/>
<path fill="#6054E8" opacity="1.000000" stroke="none" 
	d="
M98.011108,219.955215 
	C97.530647,218.533447 97.303093,217.492172 97.029388,216.147186 
	C97.301880,214.594650 97.620522,213.345840 97.959396,211.780426 
	C104.056313,204.240280 110.204445,204.392563 115.490211,212.123688 
	C115.853012,213.303299 115.959641,214.250397 116.151779,215.545288 
	C116.092438,216.798737 115.947601,217.704391 115.793205,218.940186 
	C109.653969,227.012146 104.482521,227.326645 98.011108,219.955215 
z"/>
<path fill="#88F4CC" opacity="1.000000" stroke="none" 
	d="
M81.230545,231.280609 
	C81.515594,231.506897 81.699471,231.998550 81.824173,232.756653 
	C81.553131,232.530716 81.341248,232.038361 81.230545,231.280609 
z"/>
<path fill="#88F4CC" opacity="1.000000" stroke="none" 
	d="
M81.238312,218.236130 
	C81.625885,218.185516 81.709541,218.464539 81.437088,218.915802 
	C81.262962,218.845535 81.214096,218.671432 81.238312,218.236130 
z"/>
<path fill="#F9F9FE" opacity="1.000000" stroke="none" 
	d="
M391.735840,218.620712 
	C389.244781,214.049011 389.906647,213.432648 397.906738,212.620590 
	C398.135620,211.145004 398.377136,209.587769 398.673706,207.675842 
	C393.378845,206.627487 388.214294,206.251877 385.097076,210.567322 
	C383.395111,212.923447 382.647247,217.628143 383.856628,220.110519 
	C387.217773,227.009735 393.995728,225.088013 400.480072,223.895248 
	C395.028046,231.090668 381.007446,229.245880 373.572937,220.667648 
	C379.034485,217.044693 382.115936,212.133835 380.184631,205.271118 
	C386.967896,205.271118 393.398743,205.271118 399.779144,205.271118 
	C401.714630,217.047791 400.367737,219.359772 391.735840,218.620712 
z"/>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M341.262115,205.087097 
	C344.547333,205.037949 347.368164,205.037949 350.151764,205.037949 
	C352.195801,215.135834 351.842499,216.394547 339.082703,214.548294 
	C339.654572,211.409897 340.226135,208.273087 341.262115,205.087097 
z"/>
<path fill="#F9F9FE" opacity="1.000000" stroke="none" 
	d="
M234.969879,223.397232 
	C238.401230,222.960709 241.484360,222.758987 244.567490,222.557266 
	C244.894669,223.121124 245.221863,223.684967 245.549042,224.248825 
	C243.374527,226.085312 241.423019,228.405548 238.931412,229.554291 
	C237.684875,230.128983 235.213287,228.879761 233.796219,227.799179 
	C233.300430,227.421112 234.303192,225.077881 234.969879,223.397232 
z"/>
<path fill="#F9F9FE" opacity="1.000000" stroke="none" 
	d="
M213.099396,217.656219 
	C208.922195,217.680206 205.149033,217.680206 201.090439,217.680206 
	C201.191971,213.212296 203.890869,211.827377 207.094040,211.395477 
	C210.555466,210.928802 213.268402,212.389572 214.488113,215.840820 
	C214.639267,216.268524 213.854492,217.027008 213.099396,217.656219 
z"/>
</svg>
    </div>
    <div class="side tails">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="70 20 380 500" enable-background="new 0 0 500 500" xmlSpace="preserve">
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M288.000000,501.000000 
	C192.000015,501.000000 96.500046,501.000000 1.000051,501.000000 
	C1.000034,334.333405 1.000034,167.666794 1.000017,1.000141 
	C167.666565,1.000094 334.333130,1.000094 500.999756,1.000047 
	C500.999847,167.666519 500.999847,334.333038 500.999939,500.999786 
	C430.166656,501.000000 359.333344,501.000000 288.000000,501.000000 
M98.264000,220.335724 
	C104.482521,227.326645 109.653969,227.012146 115.921989,220.283020 
	C115.952385,223.599518 115.944221,226.916901 116.022079,230.232285 
	C116.143494,235.402176 119.088997,238.722504 123.653130,238.919067 
	C128.311523,239.119705 131.828888,235.608337 131.941605,230.334152 
	C132.044281,225.530228 131.869888,220.720367 131.899307,214.991287 
	C131.914185,210.173065 132.039505,205.351898 131.911438,200.537491 
	C131.794159,196.129364 128.151550,192.626129 123.955597,192.583572 
	C119.443954,192.537811 116.253517,195.635971 116.044319,200.418427 
	C115.870392,204.394409 115.840225,208.376709 115.234039,211.891190 
	C110.204445,204.392563 104.056313,204.240280 97.825562,210.495270 
	C97.800919,207.507599 97.906235,204.511948 97.722961,201.534042 
	C97.400513,196.294922 93.558189,192.434311 88.963989,192.519104 
	C84.627800,192.599136 81.192078,196.527832 81.150505,201.741714 
	C81.112175,206.547470 81.307182,211.355087 81.285881,216.759766 
	C81.294380,217.164810 81.302887,217.569870 81.165237,218.497345 
	C81.214096,218.671432 81.262962,218.845535 81.259689,219.937271 
	C81.283699,223.629929 81.307709,227.322586 81.129372,231.545990 
	C81.341248,232.038361 81.553131,232.530716 81.978546,233.714188 
	C83.801773,237.712921 86.965866,239.634430 91.196777,238.557053 
	C95.647629,237.423676 97.410423,234.091431 97.281265,229.499466 
	C97.188416,226.198303 97.581749,222.883453 98.264000,220.335724 
M325.754486,198.342789 
	C323.843964,198.342789 321.933441,198.342789 320.050385,198.342789 
	C320.050385,201.055450 320.050385,202.936264 320.050385,205.346771 
	C324.186768,205.346771 327.923096,205.346771 332.201263,205.346771 
	C331.830811,208.176453 331.539185,210.404083 331.247559,212.631714 
	C330.979584,212.205444 330.711578,211.779190 330.443604,211.352921 
	C327.814209,211.932404 324.421661,211.693115 322.725647,213.273956 
	C319.829437,215.973541 321.995697,219.216476 324.152740,221.611511 
	C328.583069,226.530655 333.228546,231.256012 337.087250,235.324860 
	C339.526642,233.663269 341.386627,232.396317 343.268311,231.114609 
	C339.319214,227.395187 335.990631,224.260208 332.211975,220.701309 
	C339.098419,221.314240 344.792786,221.821060 351.128357,222.384964 
	C351.128357,226.437119 351.128357,230.650894 351.128357,234.652710 
	C354.020325,234.652710 356.267151,234.652710 358.939026,234.652710 
	C358.939026,224.700516 358.939026,215.109802 358.939026,205.353455 
	C363.601166,205.353455 367.821960,205.353455 372.538666,205.353455 
	C372.391724,207.956573 372.265320,210.196518 372.207428,211.222092 
	C368.677460,212.036560 364.906830,211.778030 363.336151,213.512146 
	C360.383881,216.771606 363.405884,220.096909 365.643372,222.674942 
	C374.119385,232.440811 384.386414,237.395493 397.580017,233.815201 
	C398.325012,233.613037 399.168121,233.387436 399.886688,233.541275 
	C402.558746,234.113327 405.197815,234.839493 408.717468,235.726624 
	C408.717468,224.734680 408.717468,215.020950 408.717468,205.320480 
	C411.107697,205.320480 412.854858,205.320480 415.140381,205.320480 
	C415.140381,215.337952 415.140381,225.073914 415.140381,234.726227 
	C417.949677,234.726227 420.210907,234.726227 423.026764,234.726227 
	C423.026764,224.705780 423.026764,214.966232 423.026764,205.353836 
	C425.167572,205.032669 426.732178,204.797943 428.546021,204.525833 
	C428.435577,202.284714 428.342743,200.401596 428.241302,198.343231 
	C393.957123,198.343231 360.324829,198.343231 325.754486,198.342789 
M187.340225,234.985733 
	C187.889481,233.647415 188.873840,232.321716 188.913040,230.968628 
	C189.086456,224.981491 188.988281,218.986496 188.988312,212.994339 
	C188.988358,206.732819 188.988312,200.471283 188.988312,194.363861 
	C186.046249,194.363861 183.812759,194.363861 181.143661,194.363861 
	C181.143661,199.992905 181.143661,205.249725 181.143661,210.724976 
	C174.953720,210.724976 169.222229,210.724976 162.949692,210.724976 
	C162.949692,205.086807 162.949692,199.688782 162.949692,194.320526 
	C160.165344,194.320526 157.938232,194.320526 155.716797,194.320526 
	C155.716797,208.025574 155.716797,221.385330 155.716797,234.629578 
	C158.362076,234.629578 160.586945,234.629578 163.175507,234.629578 
	C163.175507,228.645767 163.175507,223.046127 163.175507,217.302917 
	C169.292465,217.302917 175.024170,217.302917 181.363434,217.302917 
	C181.363434,223.292358 181.363434,229.017471 181.363434,235.015839 
	C183.457520,235.015839 184.942688,235.015839 187.340225,234.985733 
M298.399078,232.965775 
	C298.414673,228.639053 298.295319,224.306564 298.479614,219.987030 
	C298.716522,214.433762 301.237671,211.717545 305.767365,211.741425 
	C309.957825,211.763519 311.829987,214.197678 311.968628,220.160004 
	C312.079926,224.946762 311.991150,229.738159 311.991150,234.674942 
	C314.659973,234.674942 316.858307,234.674942 319.375336,234.674942 
	C319.375336,229.209076 319.558228,224.059570 319.339325,218.927200 
	C318.792725,206.111832 311.261749,201.917572 299.935242,207.964020 
	C299.700806,208.089157 299.298615,207.899948 298.401855,207.782166 
	C298.401855,202.966721 298.401855,198.052017 298.401855,193.043793 
	C295.602539,193.043793 293.380585,193.043793 291.175293,193.043793 
	C291.175293,207.131180 291.175293,220.872742 291.175293,235.499298 
	C293.848511,234.880081 296.076447,234.364029 298.399078,232.965775 
M228.674179,215.749390 
	C230.658295,214.910156 232.581940,213.847717 234.642227,213.289780 
	C237.067047,212.633087 239.713470,211.823166 242.062332,212.233337 
	C243.403336,212.467529 244.343109,214.999298 246.159988,217.427216 
	C242.754471,217.587906 240.972885,217.662567 239.192459,217.758575 
	C237.365936,217.857056 235.523529,217.855576 233.717926,218.109894 
	C228.842545,218.796555 225.418381,222.178253 225.123428,226.443619 
	C224.821915,230.803925 227.708939,234.878326 232.789871,235.252258 
	C236.895935,235.554443 241.129944,234.118591 245.736938,233.385330 
	C246.214066,236.945099 249.639633,234.765976 252.764908,234.740356 
	C252.764908,228.100983 253.085144,221.786957 252.672516,215.521179 
	C252.280289,209.565231 248.176315,206.092880 241.665421,205.218689 
	C235.227234,204.354248 228.830521,207.195541 226.914078,212.094513 
	C226.545456,213.036850 227.524994,214.506577 228.674179,215.749390 
M193.122116,217.102737 
	C193.087341,219.098190 192.868866,221.110596 193.050964,223.086060 
	C193.690948,230.028870 199.401932,235.221497 206.859406,235.802429 
	C213.447769,236.315659 219.087097,232.586792 221.286850,225.041199 
	C217.609024,226.267181 214.790527,227.488373 211.845428,228.101410 
	C209.385803,228.613373 206.576370,229.043243 204.303711,228.316055 
	C202.676865,227.795532 201.681213,225.302353 200.403946,223.689316 
	C200.697647,223.205978 200.991364,222.722656 201.285065,222.239334 
	C208.306122,222.239334 215.327194,222.239334 222.245697,222.239334 
	C222.970886,214.300903 220.183838,209.050583 214.318420,206.414581 
	C205.718872,202.549805 197.169525,206.564301 193.122116,217.102737 
M269.487701,205.994568 
	C268.384949,207.611710 267.282196,209.228867 265.883240,211.280350 
	C268.855804,212.034363 270.365295,212.417236 271.994049,212.830383 
	C271.994049,216.117538 271.993378,219.106918 271.994171,222.096298 
	C271.997223,233.349014 275.414246,236.251801 286.669281,234.482452 
	C286.669281,232.615829 286.669281,230.741547 286.669281,228.867264 
	C286.354523,229.159363 286.039795,229.451462 285.725037,229.743546 
	C283.701141,228.325989 280.305786,227.200211 279.929626,225.432114 
	C279.060059,221.344925 279.653351,216.946503 279.653351,212.447800 
	C282.411407,212.220291 284.664551,212.034439 287.125244,211.831482 
	C287.125244,209.879257 287.125244,208.125320 287.125244,206.219574 
	C284.604614,206.043625 282.336609,205.885300 279.889587,205.714493 
	C279.658203,203.091995 279.447144,200.699615 279.239624,198.347504 
	C276.885529,198.347504 274.969543,198.347504 273.620361,198.347504 
	C272.413330,201.179688 271.392731,203.574387 269.487701,205.994568 
M257.680786,193.060974 
	C257.413757,194.471344 256.922974,195.880463 256.915039,197.292282 
	C256.851746,208.577347 256.867126,219.862961 256.897827,231.148300 
	C256.901215,232.395538 257.152161,233.642136 257.260742,234.636658 
	C259.805603,234.636658 261.882172,234.636658 263.873352,234.636658 
	C263.873352,220.579254 263.873352,206.892059 263.873352,192.886795 
	C261.883057,192.886795 260.249725,192.886795 257.680786,193.060974 
z"/>
<path fill="#655AE9" opacity="1.000000" stroke="none" 
	d="
M326.223511,198.343018 
	C360.324829,198.343231 393.957123,198.343231 428.241302,198.343231 
	C428.342743,200.401596 428.435577,202.284714 428.546021,204.525833 
	C426.732178,204.797943 425.167572,205.032669 423.026764,205.353836 
	C423.026764,214.966232 423.026764,224.705780 423.026764,234.726227 
	C420.210907,234.726227 417.949677,234.726227 415.140381,234.726227 
	C415.140381,225.073914 415.140381,215.337952 415.140381,205.320480 
	C412.854858,205.320480 411.107697,205.320480 408.717468,205.320480 
	C408.717468,215.020950 408.717468,224.734680 408.717468,235.726624 
	C405.197815,234.839493 402.558746,234.113327 399.886688,233.541275 
	C399.168121,233.387436 398.325012,233.613037 397.580017,233.815201 
	C384.386414,237.395493 374.119385,232.440811 365.643372,222.674942 
	C363.405884,220.096909 360.383881,216.771606 363.336151,213.512146 
	C364.906830,211.778030 368.677460,212.036560 372.207428,211.222092 
	C372.265320,210.196518 372.391724,207.956573 372.538666,205.353455 
	C367.821960,205.353455 363.601166,205.353455 358.939026,205.353455 
	C358.939026,215.109802 358.939026,224.700516 358.939026,234.652710 
	C356.267151,234.652710 354.020325,234.652710 351.128357,234.652710 
	C351.128357,230.650894 351.128357,226.437119 351.128357,222.384964 
	C344.792786,221.821060 339.098419,221.314240 332.211975,220.701309 
	C335.990631,224.260208 339.319214,227.395187 343.268311,231.114609 
	C341.386627,232.396317 339.526642,233.663269 337.087250,235.324860 
	C333.228546,231.256012 328.583069,226.530655 324.152740,221.611511 
	C321.995697,219.216476 319.829437,215.973541 322.725647,213.273956 
	C324.421661,211.693115 327.814209,211.932404 330.443604,211.352921 
	C330.711578,211.779190 330.979584,212.205444 331.247559,212.631714 
	C331.539185,210.404083 331.830811,208.176453 332.201263,205.346771 
	C327.923096,205.346771 324.186768,205.346771 320.050385,205.346771 
	C320.050385,202.936264 320.050385,201.055450 320.050385,198.342789 
	C321.933441,198.342789 323.843964,198.342789 326.223511,198.343018 
M392.087799,218.820801 
	C400.367737,219.359772 401.714630,217.047791 399.779144,205.271118 
	C393.398743,205.271118 386.967896,205.271118 380.184631,205.271118 
	C382.115936,212.133835 379.034485,217.044693 373.572937,220.667648 
	C381.007446,229.245880 395.028046,231.090668 400.480072,223.895248 
	C393.995728,225.088013 387.217773,227.009735 383.856628,220.110519 
	C382.647247,217.628143 383.395111,212.923447 385.097076,210.567322 
	C388.214294,206.251877 393.378845,206.627487 398.673706,207.675842 
	C398.377136,209.587769 398.135620,211.145004 397.906738,212.620590 
	C389.906647,213.432648 389.244781,214.049011 392.087799,218.820801 
M340.797729,205.136261 
	C340.226135,208.273087 339.654572,211.409897 339.082703,214.548294 
	C351.842499,216.394547 352.195801,215.135834 350.151764,205.037949 
	C347.368164,205.037949 344.547333,205.037949 340.797729,205.136261 
z"/>
<path fill="#655AE9" opacity="1.000000" stroke="none" 
	d="
M186.884033,235.000793 
	C184.942688,235.015839 183.457520,235.015839 181.363434,235.015839 
	C181.363434,229.017471 181.363434,223.292358 181.363434,217.302917 
	C175.024170,217.302917 169.292465,217.302917 163.175507,217.302917 
	C163.175507,223.046127 163.175507,228.645767 163.175507,234.629578 
	C160.586945,234.629578 158.362076,234.629578 155.716797,234.629578 
	C155.716797,221.385330 155.716797,208.025574 155.716797,194.320526 
	C157.938232,194.320526 160.165344,194.320526 162.949692,194.320526 
	C162.949692,199.688782 162.949692,205.086807 162.949692,210.724976 
	C169.222229,210.724976 174.953720,210.724976 181.143661,210.724976 
	C181.143661,205.249725 181.143661,199.992905 181.143661,194.363861 
	C183.812759,194.363861 186.046249,194.363861 188.988312,194.363861 
	C188.988312,200.471283 188.988358,206.732819 188.988312,212.994339 
	C188.988281,218.986496 189.086456,224.981491 188.913040,230.968628 
	C188.873840,232.321716 187.889481,233.647415 186.884033,235.000793 
z"/>
<path fill="#6054E8" opacity="1.000000" stroke="none" 
	d="
M298.351715,233.406860 
	C296.076447,234.364029 293.848511,234.880081 291.175293,235.499298 
	C291.175293,220.872742 291.175293,207.131180 291.175293,193.043793 
	C293.380585,193.043793 295.602539,193.043793 298.401855,193.043793 
	C298.401855,198.052017 298.401855,202.966721 298.401855,207.782166 
	C299.298615,207.899948 299.700806,208.089157 299.935242,207.964020 
	C311.261749,201.917572 318.792725,206.111832 319.339325,218.927200 
	C319.558228,224.059570 319.375336,229.209076 319.375336,234.674942 
	C316.858307,234.674942 314.659973,234.674942 311.991150,234.674942 
	C311.991150,229.738159 312.079926,224.946762 311.968628,220.160004 
	C311.829987,214.197678 309.957825,211.763519 305.767365,211.741425 
	C301.237671,211.717545 298.716522,214.433762 298.479614,219.987030 
	C298.295319,224.306564 298.414673,228.639053 298.351715,233.406860 
z"/>
<path fill="#655AE9" opacity="1.000000" stroke="none" 
	d="
M228.278381,215.741196 
	C227.524994,214.506577 226.545456,213.036850 226.914078,212.094513 
	C228.830521,207.195541 235.227234,204.354248 241.665421,205.218689 
	C248.176315,206.092880 252.280289,209.565231 252.672516,215.521179 
	C253.085144,221.786957 252.764908,228.100983 252.764908,234.740356 
	C249.639633,234.765976 246.214066,236.945099 245.736938,233.385330 
	C241.129944,234.118591 236.895935,235.554443 232.789871,235.252258 
	C227.708939,234.878326 224.821915,230.803925 225.123428,226.443619 
	C225.418381,222.178253 228.842545,218.796555 233.717926,218.109894 
	C235.523529,217.855576 237.365936,217.857056 239.192459,217.758575 
	C240.972885,217.662567 242.754471,217.587906 246.159988,217.427216 
	C244.343109,214.999298 243.403336,212.467529 242.062332,212.233337 
	C239.713470,211.823166 237.067047,212.633087 234.642227,213.289780 
	C232.581940,213.847717 230.658295,214.910156 228.278381,215.741196 
M234.621643,223.632034 
	C234.303192,225.077881 233.300430,227.421112 233.796219,227.799179 
	C235.213287,228.879761 237.684875,230.128983 238.931412,229.554291 
	C241.423019,228.405548 243.374527,226.085312 245.549042,224.248825 
	C245.221863,223.684967 244.894669,223.121124 244.567490,222.557266 
	C241.484360,222.758987 238.401230,222.960709 234.621643,223.632034 
z"/>
<path fill="#655AE9" opacity="1.000000" stroke="none" 
	d="
M193.207962,216.694870 
	C197.169525,206.564301 205.718872,202.549805 214.318420,206.414581 
	C220.183838,209.050583 222.970886,214.300903 222.245697,222.239334 
	C215.327194,222.239334 208.306122,222.239334 201.285065,222.239334 
	C200.991364,222.722656 200.697647,223.205978 200.403946,223.689316 
	C201.681213,225.302353 202.676865,227.795532 204.303711,228.316055 
	C206.576370,229.043243 209.385803,228.613373 211.845428,228.101410 
	C214.790527,227.488373 217.609024,226.267181 221.286850,225.041199 
	C219.087097,232.586792 213.447769,236.315659 206.859406,235.802429 
	C199.401932,235.221497 193.690948,230.028870 193.050964,223.086060 
	C192.868866,221.110596 193.087341,219.098190 193.207962,216.694870 
M213.503418,217.632233 
	C213.854492,217.027008 214.639267,216.268524 214.488113,215.840820 
	C213.268402,212.389572 210.555466,210.928802 207.094040,211.395477 
	C203.890869,211.827377 201.191971,213.212296 201.090439,217.680206 
	C205.149033,217.680206 208.922195,217.680206 213.503418,217.632233 
z"/>
<path fill="#6054E8" opacity="1.000000" stroke="none" 
	d="
M269.929932,205.981842 
	C271.392731,203.574387 272.413330,201.179688 273.620361,198.347504 
	C274.969543,198.347504 276.885529,198.347504 279.239624,198.347504 
	C279.447144,200.699615 279.658203,203.091995 279.889587,205.714493 
	C282.336609,205.885300 284.604614,206.043625 287.125244,206.219574 
	C287.125244,208.125320 287.125244,209.879257 287.125244,211.831482 
	C284.664551,212.034439 282.411407,212.220291 279.653351,212.447800 
	C279.653351,216.946503 279.060059,221.344925 279.929626,225.432114 
	C280.305786,227.200211 283.701141,228.325989 285.725037,229.743546 
	C286.039795,229.451462 286.354523,229.159363 286.669281,228.867264 
	C286.669281,230.741547 286.669281,232.615829 286.669281,234.482452 
	C275.414246,236.251801 271.997223,233.349014 271.994171,222.096298 
	C271.993378,219.106918 271.994049,216.117538 271.994049,212.830383 
	C270.365295,212.417236 268.855804,212.034363 265.883240,211.280350 
	C267.282196,209.228867 268.384949,207.611710 269.929932,205.981842 
z"/>
<path fill="#88F4CC" opacity="1.000000" stroke="none" 
	d="
M81.399399,216.161896 
	C81.307182,211.355087 81.112175,206.547470 81.150505,201.741714 
	C81.192078,196.527832 84.627800,192.599136 88.963989,192.519104 
	C93.558189,192.434311 97.400513,196.294922 97.722961,201.534042 
	C97.906235,204.511948 97.800919,207.507599 97.882362,211.296143 
	C97.620522,213.345840 97.301880,214.594650 96.518852,215.867401 
	C91.169441,215.981522 86.284424,216.071701 81.399399,216.161896 
z"/>
<path fill="#FDCD6F" opacity="1.000000" stroke="none" 
	d="
M115.746384,212.356201 
	C115.840225,208.376709 115.870392,204.394409 116.044319,200.418427 
	C116.253517,195.635971 119.443954,192.537811 123.955597,192.583572 
	C128.151550,192.626129 131.794159,196.129364 131.911438,200.537491 
	C132.039505,205.351898 131.914185,210.173065 131.408127,215.461288 
	C126.023720,215.918549 121.130501,215.905807 116.151779,215.545288 
	C115.959641,214.250397 115.853012,213.303299 115.746384,212.356201 
z"/>
<path fill="#F76FB8" opacity="1.000000" stroke="none" 
	d="
M116.237274,215.893066 
	C121.130501,215.905807 126.023720,215.918549 131.367279,215.922211 
	C131.869888,220.720367 132.044281,225.530228 131.941605,230.334152 
	C131.828888,235.608337 128.311523,239.119705 123.653130,238.919067 
	C119.088997,238.722504 116.143494,235.402176 116.022079,230.232285 
	C115.944221,226.916901 115.952385,223.599518 115.862381,219.446533 
	C115.947601,217.704391 116.092438,216.798737 116.237274,215.893066 
z"/>
<path fill="#2BC8F6" opacity="1.000000" stroke="none" 
	d="
M81.342636,216.460831 
	C86.284424,216.071701 91.169441,215.981522 96.565002,216.171127 
	C97.303093,217.492172 97.530647,218.533447 97.758209,219.574707 
	C97.581749,222.883453 97.188416,226.198303 97.281265,229.499466 
	C97.410423,234.091431 95.647629,237.423676 91.196777,238.557053 
	C86.965866,239.634430 83.801773,237.712921 81.930946,233.102203 
	C81.699471,231.998550 81.515594,231.506897 81.331711,231.015244 
	C81.307709,227.322586 81.283699,223.629929 81.411018,219.374619 
	C81.709541,218.464539 81.625885,218.185516 81.311386,217.974915 
	C81.302887,217.569870 81.294380,217.164810 81.342636,216.460831 
z"/>
<path fill="#6054E8" opacity="1.000000" stroke="none" 
	d="
M258.148590,192.973877 
	C260.249725,192.886795 261.883057,192.886795 263.873352,192.886795 
	C263.873352,206.892059 263.873352,220.579254 263.873352,234.636658 
	C261.882172,234.636658 259.805603,234.636658 257.260742,234.636658 
	C257.152161,233.642136 256.901215,232.395538 256.897827,231.148300 
	C256.867126,219.862961 256.851746,208.577347 256.915039,197.292282 
	C256.922974,195.880463 257.413757,194.471344 258.148590,192.973877 
z"/>
<path fill="#6054E8" opacity="1.000000" stroke="none" 
	d="
M98.011108,219.955215 
	C97.530647,218.533447 97.303093,217.492172 97.029388,216.147186 
	C97.301880,214.594650 97.620522,213.345840 97.959396,211.780426 
	C104.056313,204.240280 110.204445,204.392563 115.490211,212.123688 
	C115.853012,213.303299 115.959641,214.250397 116.151779,215.545288 
	C116.092438,216.798737 115.947601,217.704391 115.793205,218.940186 
	C109.653969,227.012146 104.482521,227.326645 98.011108,219.955215 
z"/>
<path fill="#88F4CC" opacity="1.000000" stroke="none" 
	d="
M81.230545,231.280609 
	C81.515594,231.506897 81.699471,231.998550 81.824173,232.756653 
	C81.553131,232.530716 81.341248,232.038361 81.230545,231.280609 
z"/>
<path fill="#88F4CC" opacity="1.000000" stroke="none" 
	d="
M81.238312,218.236130 
	C81.625885,218.185516 81.709541,218.464539 81.437088,218.915802 
	C81.262962,218.845535 81.214096,218.671432 81.238312,218.236130 
z"/>
<path fill="#F9F9FE" opacity="1.000000" stroke="none" 
	d="
M391.735840,218.620712 
	C389.244781,214.049011 389.906647,213.432648 397.906738,212.620590 
	C398.135620,211.145004 398.377136,209.587769 398.673706,207.675842 
	C393.378845,206.627487 388.214294,206.251877 385.097076,210.567322 
	C383.395111,212.923447 382.647247,217.628143 383.856628,220.110519 
	C387.217773,227.009735 393.995728,225.088013 400.480072,223.895248 
	C395.028046,231.090668 381.007446,229.245880 373.572937,220.667648 
	C379.034485,217.044693 382.115936,212.133835 380.184631,205.271118 
	C386.967896,205.271118 393.398743,205.271118 399.779144,205.271118 
	C401.714630,217.047791 400.367737,219.359772 391.735840,218.620712 
z"/>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M341.262115,205.087097 
	C344.547333,205.037949 347.368164,205.037949 350.151764,205.037949 
	C352.195801,215.135834 351.842499,216.394547 339.082703,214.548294 
	C339.654572,211.409897 340.226135,208.273087 341.262115,205.087097 
z"/>
<path fill="#F9F9FE" opacity="1.000000" stroke="none" 
	d="
M234.969879,223.397232 
	C238.401230,222.960709 241.484360,222.758987 244.567490,222.557266 
	C244.894669,223.121124 245.221863,223.684967 245.549042,224.248825 
	C243.374527,226.085312 241.423019,228.405548 238.931412,229.554291 
	C237.684875,230.128983 235.213287,228.879761 233.796219,227.799179 
	C233.300430,227.421112 234.303192,225.077881 234.969879,223.397232 
z"/>
<path fill="#F9F9FE" opacity="1.000000" stroke="none" 
	d="
M213.099396,217.656219 
	C208.922195,217.680206 205.149033,217.680206 201.090439,217.680206 
	C201.191971,213.212296 203.890869,211.827377 207.094040,211.395477 
	C210.555466,210.928802 213.268402,212.389572 214.488113,215.840820 
	C214.639267,216.268524 213.854492,217.027008 213.099396,217.656219 
z"/>
</svg>


  
  </div>
  </div></div>
  )
}

export default Future